import { createBrowserHistory } from 'history';
import i18n from 'i18next';

export const browserHistory = createBrowserHistory();

const availableTitles = {
  '/': i18n.t('router:profile'),
  '/profile': i18n.t('router:profile'),
  '/password': i18n.t('router:password'),
  '/2fa': i18n.t('router:2fa'),
  '/kyc': i18n.t('router:kyc')
};

export const updateDocumentTitle = (title, init = false) => {
  const {
    location: { pathname }
  } = browserHistory;

  if (title) {
    const pathSlug = availableTitles[pathname]
      ? availableTitles[pathname]
      : i18n.t('router:profile');

    document.title = `${title} - ${pathSlug}`;
  }
  if (!init) window.scrollTo(0, 0);
};

export default browserHistory;
